module.exports = __webpack_public_path__ + "img/qy_8.5b30c460.png";